export class Savingcreateuser {
    public firstName :string;
    public lastName : string;
    public emailAddress : string;
    public roleId : string;
    public accessLevel : string;
    
    public password : string;
    public selectedlocations : any[];

    

    constructor(
        firstName :string,
        lastName : string,
        emailAddress : string,
        roleId : string,
        accessLevel : string,
        
        password : string,
        selectedlocations : any[]
  ){
    this.firstName=firstName;
    this.lastName=lastName;
    this.emailAddress=emailAddress;
    this.roleId=roleId;
    this.accessLevel=accessLevel;
  
    this.password=password;
    this.selectedlocations = selectedlocations
  
    }
}
